<template>
  <div ref="scrollToMe" v-if="item">
    <div class="border" v-if="!isPayment">
      <!-- <fields-list :item="item" :fields="fields" @change="updateItem" /> -->
      <h6 v-if="item.status">
        Статус:
        <span class="text-info">{{ item.status.name }} </span>
      </h6>
      <h6>
        Создан:
        <span class="text-info">{{ item.created_at | dateTimeFormat }} </span>
      </h6>
      <h6>
        Стоимость заказа:
        <span class="text-info"
          >{{ item.price_total | spaceBetweenNumber }} UZS
        </span>
      </h6>
      <template v-if="item.client">
        <h6 v-if="item.client.phone">
          Номер телефона:
          <span class="text-info"> {{ item.client.phone }}</span>
        </h6>
        <h6 v-if="item.shop">
          Магазин: <span class="text-info"> {{ item.shop.name }}</span>
        </h6>
        <h6 v-if="item.client.first_name || item.client.last_name">
          Имя:
          <span class="text-info">
            {{ item.client.first_name }} {{ item.client.last_name }}
          </span>
        </h6>
      </template>
    </div>

    <div v-if="!isPayment">
      <div class="border">
        <purchases @deleted="refresh" :id="id" @added="update" :order="item" />
        <promotions :order="item" />
      </div>
    </div>

    <partners :id="id" @close="payment" :order="item" @updateOrder="refresh" />

    <!-- <div v-if="!isPayment">
      <transactions :id="id" />
    </div> -->
  </div>
</template>

<script>
import { cardUpdate, cardContent, pushLang } from "@/plugins/functions";
import { mapState } from "vuex";
import { logger } from "../../../plugins/functions";

export default {
  components: {
    purchases: () => import("./Purchases"),
    promotions: () => import("./Promotions"),
    client: () => import("./Client"),
    cards: () => import("./Client/Cards"),
    partners: () => import("@/components/Partners"),
    transactions: () => import("./Transactions"),
    services: () => import("./Services"),
  },
  computed: {
    ...mapState(["lastUpdate"]),
  },
  data: () => ({
    isPayment: false,
    cardLink: "orders",
    cardSetLink: "orders",
    item: null,
    fields: [
      {
        col: " col-12 col-md-12",
        key: "status",
        labelKey: "status",
        label: "Статус заказа",
        type: "select",
        modal: "status",
        selectKey: "name",
      },
      // {
      //   col: " col-12 col-md-12",
      //   key: "card_id",
      //   type: "hidden",
      // },
    ],
  }),
  props: ["id"],
  async created() {
    await this.refresh();
    logger(this.$http, {
      name: "Открыт заказ",
      description: `Заказ # ${this.id}`,
      model_type: "order",
      model_id: this.id,
    });
  },
  methods: {
    setStatus(val) {
      this.$loading(true);

      this.$loading(false);
    },
    payment(val) {
      const el = this.$refs.scrollToMe;

      if (el) {
        // Use el.scrollIntoView() to instantly scroll to the element
        el.scrollIntoView({ behavior: "smooth" });
      }
      this.isPayment = val;
    },
    update() {
      setTimeout(() => {
        this.refresh();
      }, 1);
    },
    cardUpdate: cardUpdate,
    cardContent: cardContent,
    pushLang: pushLang,
    async refresh() {
      this.item = await this.cardContent(this.cardLink, this.id);
    },
    async updateItem() {
      logger(this.$http, {
        name: `Изменение  статуса`,
        description: `Заказ #cb_order_${this.item.id}`,
      });
      let item = await this.cardUpdate(
        this.cardSetLink,
        this.item,
        this.fields
      );

      if (!item) {
        this.item["status_id"] = null;
        this.item["status"] = null;
      }
    },
    showShop(shopId = {}) {
      let query = Object.assign({}, this.$route.query);
      if (query["item_shop"] == shopId) {
        return false;
      }

      if (query["item_shop"]) {
        delete query["item_shop"];
      }

      query["item_shop"] = shopId;
      setTimeout(() => {
        this.$router.replace({ query: query });
      }, 20);
    },
  },
  watch: {
    lastUpdate(val) {
      if (val) {
        this.refresh();
      }
    },
  },
};
</script>
<style>
</style>
